


























import { Component, Vue } from 'vue-property-decorator'
import { PreviewMixedPayRelease, HandleMixedPayRelease } from '@/api'
import { OrderStatusFormat } from '@/utils/tyepconvert'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message } from 'element-ui'

@Component
export default class MixedPayAbnormalDialog extends Vue {
  private visible = false
  private loading = false
  private submitting = false
  private preview: any = null
  private orderStatusText = ''

  public async open(orderCode: string, orderStatus?: number) {
    this.visible = true
    this.preview = null
    this.orderStatusText = orderStatus != null ? OrderStatusFormat(orderStatus) : '-'
    this.loading = true
    try {
      this.preview = await PreviewMixedPayRelease({ orderCode })
      if (!this.preview.abnormal) {
        Message.info(this.preview.abnormalDesc || '当前无待释放混合抵扣')
      }
    } finally {
      this.loading = false
    }
  }

  private fenToYuan(fen: number) {
    if (fen == null || fen === 0) {
      return '0.00'
    }
    return (fen / 100).toFixed(2)
  }

  private formatTime(t: any) {
    return t ? DateFormat(t) : '-'
  }

  private async confirmHandle() {
    if (!this.preview || !this.preview.orderCode) {
      return
    }
    this.submitting = true
    try {
      const res = await HandleMixedPayRelease({ orderCode: this.preview.orderCode })
      if (res && res.stillAbnormal) {
        Message.warning('已执行释放，但仍存在异常，请刷新后重试或联系技术')
      } else {
        Message.success('混合抵扣已释放，绿豆/积分将退回用户账户')
      }
      this.visible = false
      this.$emit('done')
    } finally {
      this.submitting = false
    }
  }

  private onClose() {
    this.preview = null
  }
}
